<template>
  <b-container fluid>
    <b-row class="mb-2">
      <b-col class="px-sm-3 px-0">
        <h1>Menus</h1>
        <div v-if="organizationIds.length > 1" class="mt-2">
          <label for="organization-select" class="form-label">
            Organization:
          </label>
          <b-form-select
            id="organization-select"
            v-model="selectedOrganizationId"
            :options="organizationOptions"
            class="w-auto"
            @change="onOrganizationChange"
          />
        </div>
      </b-col>
    </b-row>
    <b-row class="overflow-auto">
      <b-col class="px-sm-3 px-0">
        <b-table
          hover
          no-local-sorting
          small
          :fields="fields"
          :items="data"
          :busy="busy"
          @sort-changed="onSortingChanged"
          @row-clicked="onRowClicked"
        >
          <template #cell(facility)="row">
            {{ row.item.facility ? row.item.facility.name : '-' }}
          </template>
        </b-table>
      </b-col>
    </b-row>
    <pagination-handler v-if="data.length" :query-data="queryFilters" />
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import tableMixin from '../../mixins/TableMixin';
import OrganizationMenusAPI from '../../services/OrganizationMenusAPI';
import OrganizationsAPI from '../../services/OrganizationsAPI';

export default {
  name: 'OrganizationMenus',
  mixins: [tableMixin],
  data() {
    return {
      selectedOrganizationId: null,
      organizations: [],
      rowRouteName: 'organization-menu',
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'facility',
          label: 'Hub',
          sortable: false,
        },
        {
          key: 'menu_category_count',
          label: '# Categories',
          sortable: false,
        },
        {
          key: 'menu_item_count',
          label: '# Items',
          sortable: false,
        },
      ],
      data: [],
    };
  },
  computed: {
    ...mapGetters('session', ['organizationAdmin', 'organizationIds']),
    currentOrganizationId() {
      return (
        this.selectedOrganizationId ||
        (this.organizationIds.length > 0 ? this.organizationIds[0] : null)
      );
    },
    organizationOptions() {
      return this.organizationIds.map((id) => {
        const org = this.organizations.find((o) => o.id === id);
        return {
          value: id,
          text: org ? org.name || `Organization ${id}` : `Organization ${id}`,
        };
      });
    },
  },
  created() {
    if (!this.organizationAdmin) {
      this.$router.push('/');
      return;
    }
    if (this.organizationIds.length > 0) {
      [this.selectedOrganizationId] = this.organizationIds;
    }
    this.loadOrganizations();
  },
  methods: {
    async loadOrganizations() {
      if (this.organizationIds.length <= 1) {
        return;
      }
      try {
        const response = await OrganizationsAPI.getOrganizations(
          this.organizationIds
        );
        this.organizations = response.data.data || response.data;
      } catch (error) {
        try {
          const response = await OrganizationsAPI.getOrganizationsByString(
            this.organizationIds
          );
          this.organizations = response.data.data || response.data;
        } catch (stringError) {
          try {
            const promises = this.organizationIds.map((id) =>
              OrganizationsAPI.getOrganization(id)
            );
            const responses = await Promise.all(promises);
            this.organizations = responses.map(
              (response) => response.data.data || response.data
            );
          } catch (individualError) {
            this.organizations = [];
          }
        }
      }
    },
    onOrganizationChange() {
      this.queryFilters.page = 1;
      this.loadResults();
    },
    loadResults() {
      if (!this.currentOrganizationId) {
        return;
      }

      this.setRequestData();

      const searchParams = { ...this.queryFilters };
      searchParams.withCount = 'menuCategories,menuItems';

      return OrganizationMenusAPI.getMenus(
        this.currentOrganizationId,
        searchParams
      )
        .then((response) => {
          // Handle both direct pagination and meta-wrapped pagination
          const data = {
            data: response.data || response,
            total: response.total || response.meta?.total || 0,
            from: response.from || response.meta?.from || 0,
            to: response.to || response.meta?.to || 0,
          };
          this.setResponseData(data);
        })
        .catch((error) => alert(error));
    },
  },
};
</script>
